export default __webpack_public_path__ + "static/media/whatsapp.7f02d15e.png";